module.exports = __webpack_public_path__ + "static/img/box1-config.f7c9fa8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/box1-config.png
// module id = POyn
// module chunks = 1